export default {
    city: (data, p) => ({
      header: `Запчасти на водный транспорт ${p.t(data.city)}`,
      header_uk: `Запчастини на водний транспорт ${p.t(data.city)}`,

      title: `Запчасти на водный транспорт купить ${p.inCity} - Автобазар`,
      title_uk: `Запчастини на водний транспорт купити ${p.inCity} - Автобазар`,
  
      description: `Купить запчасти на водный транспорт ${p.inCity}. Большой каталог судовых запчастей бу и новых на Автобазар. Объявления с ценами и фото. Продажа от официальных диллеров и частных лиц`,
      description_uk: `Купити запчастини на водний транспорт ${p.inCity}. Великий каталог суднових запчастин бу та нових на Автобазар. Оголошення з цінами і фото. Продаж від офіційних диллерів і приватних осіб`,
    }),
  };
  


// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/templates.js